import {
   Modal,
   ModalOverlay,
   ModalContent,
   useColorModeValue,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   ModalFooter,
   Flex,
   Box,
   Button,
   Table,
   Thead,
   Tbody,
   Tr,
   Th,
   Td,
   Checkbox,
   TableContainer,
} from '@chakra-ui/react';
import React, { useState, useMemo, useEffect } from 'react';
import { useCallback } from 'react';

const SelectTakaDetail = ({ isOpen, onClose, onCloseComplete, takaDetails = [], handleSaveTakaDetail }) => {
   // console.log('takaDetails', takaDetails);
   const takaDetailsWithIds = useMemo(() => {
      return takaDetails.map((item) => ({
         ...item,
         id: item.id,
      }));
   }, [takaDetails]);

   const [selectedIds, setSelectedIds] = useState([]);

   const handleOnClose = useCallback(() => {
      onClose();
      setSelectedIds([]);
   }, [onClose]);

   const toggleItemSelection = useCallback((id) => {
      setSelectedIds((prev) => {
         if (prev.includes(id)) {
            return prev.filter((itemId) => itemId !== id);
         } else {
            return [...prev, id];
         }
      });
   }, []);

   const selectAll = useCallback(() => {
      if (selectedIds.length === takaDetailsWithIds.length) {
         setSelectedIds([]);
      } else {
         setSelectedIds(takaDetailsWithIds.map((item) => item.id));
      }
   }, [takaDetailsWithIds.length, selectedIds.length]);

   const totalSelected = useMemo(() => {
      return takaDetailsWithIds
         .filter((item) => selectedIds.includes(item.id))
         .reduce((sum, item) => sum + (item.quantity3 || 0), 0);
   }, [selectedIds, takaDetailsWithIds]);

   const allSelected = selectedIds.length === takaDetailsWithIds.length && takaDetailsWithIds.length > 0;
   const isIndeterminate = selectedIds.length > 0 && selectedIds.length < takaDetailsWithIds.length;

   const handleSave = useCallback(() => {
      onClose();

      // const selectedTakaDetails = takaDetailsWithIds.filter((item) => selectedIds.includes(item.id));
      const selectedTakaDetails = takaDetailsWithIds.map((item) => {
         if (selectedIds.includes(item.id)) {
            return {
               ...item,
               quantity3: item.quantity3,
               isSelected: true,
            };
         }
         return {
            ...item,
            isSelected: false,
         };
      });

      handleSaveTakaDetail(selectedTakaDetails);

      setSelectedIds([]);
   }, [handleSaveTakaDetail, onClose, selectedIds, takaDetailsWithIds]);

   useEffect(() => {
      if (isOpen && takaDetails.length > 0) {
         setSelectedIds(takaDetails.filter((a) => a.isSelected).map((x) => x.id));
      }

      return () => {};
   }, [isOpen, takaDetails.length]);

   return (
      <Modal isOpen={isOpen} onClose={handleOnClose} isCentered onCloseComplete={onCloseComplete}>
         <ModalOverlay />
         <ModalContent
            bg={useColorModeValue('white', '#2d3748')}
            color={useColorModeValue('gray.800', 'white')}
            borderRadius="20px"
            p={5}
            boxShadow="lg">
            <ModalHeader>
               <Flex justifyContent="space-between" alignItems="center">
                  <Box>Taka Details ({selectedIds.length})</Box>
                  <Box>Total: {totalSelected}</Box>
               </Flex>
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody>
               <Box maxH="400px" overflowY="auto">
                  <TableContainer border="1px" borderColor="gray.200" borderRadius={5}>
                     <Table variant="simple" border="1px solid #E2E8F0" size="md" width="100%">
                        <Thead>
                           <Tr>
                              <Th>
                                 <Checkbox
                                    isChecked={allSelected}
                                    isIndeterminate={isIndeterminate}
                                    onChange={selectAll}
                                 />
                              </Th>
                              <Th isNumeric>Takas</Th>
                           </Tr>
                        </Thead>
                        <Tbody>
                           {takaDetailsWithIds.map((taka) => (
                              <Tr key={taka.id}>
                                 <Td>
                                    <Checkbox
                                       isChecked={selectedIds.includes(taka.id)}
                                       onChange={() => toggleItemSelection(taka.id)}
                                    />
                                 </Td>
                                 <Td isNumeric>{taka.quantity3}</Td>
                              </Tr>
                           ))}
                        </Tbody>
                     </Table>
                  </TableContainer>
               </Box>
            </ModalBody>
            <ModalFooter>
               <Flex>
                  <Button
                     colorScheme="blue"
                     ml={3}
                     width="100%"
                     _focus={{ outlineColor: 'blue.500' }}
                     onClick={handleSave}>
                     Save
                  </Button>
                  <Button colorScheme="red" onClick={() => handleOnClose()} ml={3} width="100%">
                     Cancel
                  </Button>
               </Flex>
            </ModalFooter>
         </ModalContent>
      </Modal>
   );
};

export default SelectTakaDetail;
